import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { cn } from '@ui/primitives/utils';
import { RouteNames } from '@ui/routes';
import { Cloud, FolderGit, GitBranch } from 'lucide-react';
function ItemCounter(param) {
    let { counters, hostPlatform, params } = param;
    var _params_application;
    const itemClass = 'flex items-center gap-1 text-sm';
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            !!counters.applications && /*#__PURE__*/ _jsxs(Link, {
                className: itemClass,
                to: RouteNames.PROJECT_APPLICATION_LIST,
                params: {
                    organization: params.organization,
                    project: params.project
                },
                children: [
                    /*#__PURE__*/ _jsx(FolderGit, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: counters.applications
                    })
                ]
            }),
            !!counters.remotes && /*#__PURE__*/ _jsxs(Link, {
                className: cn(itemClass, !params.application && 'cursor-not-allowed opacity-50'),
                to: RouteNames.APPLICATION_OVERVIEW,
                params: {
                    organization: params.organization,
                    project: params.project,
                    application: (_params_application = params.application) !== null && _params_application !== void 0 ? _params_application : ''
                },
                disabled: !params.application,
                children: [
                    /*#__PURE__*/ _jsx(GitBranch, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: counters.remotes
                    })
                ]
            }),
            !!hostPlatform && /*#__PURE__*/ _jsxs("div", {
                className: cn(itemClass, 'cursor-not-allowed'),
                children: [
                    /*#__PURE__*/ _jsx(Cloud, {
                        className: "h-4 w-4",
                        style: {
                            stroke: '#27584D'
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: hostPlatform
                    })
                ]
            })
        ]
    });
}
export { ItemCounter };
